export class ShutdownHandler {
    constructor(log) {
        this.log = log;
        this.consumed = false;
        this.handlers = [];
        this.reset = () => {
            this.consumed = false;
        };
    }
    register(handler) {
        this.handlers.push(handler);
    }
    async shutdown() {
        var _a;
        if (this.consumed) {
            (_a = this.log) === null || _a === void 0 ? void 0 : _a.call(this, 'warn', 'ShutdownHandler already consumed');
        }
        this.consumed = true;
        await Promise.all(this.handlers.map((handler) => handler()));
        this.handlers.length = 0;
    }
    get isShuttingDown() {
        return this.consumed;
    }
}
//# sourceMappingURL=ShutdownHandler.js.map